import o from "./generateUtilityClass.mjs";
import t from "./generateUtilityClasses.mjs";
function l(r) {
  return o("MuiFormControl", r);
}
t("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
export {
  l as getFormControlUtilityClasses
};
//# sourceMappingURL=formControlClasses.mjs.map
